var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatAttachmentActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.43,
    height: 17.429,
    viewBox: "0 0 18 18.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160484",
    "data-name": "Group 160484",
    transform: "translate(0 0.026)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attach-outline",
    d: "M163,84.637v6.739a1.814,1.814,0,1,0,3.626,0l.006-8.834a3.075,3.075,0,1,0-6.146,0v8.893a4.323,4.323,0,1,0,8.64,0v-8.31",
    transform: "translate(-155.806 -78.636)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatAttachmentActiveIcon);
export default __webpack_public_path__ + "static/media/live-chat-attachment-active-icon.b8a74cd2519796cfb8e985627e850e76.svg";
export { ForwardRef as ReactComponent };